import React, { Component } from "react";
import { connect } from "react-redux";
import { CircularProgress } from "@material-ui/core";

import LoginWrapper from "../../components/CustomComponents/LoginWrapper";

// reducer actions
import { login, register } from "./reducer/actions";

import { Button, Grid } from "@material-ui/core";

import { TextField, InputAdornment, IconButton } from "@material-ui/core";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

// const validateEmail = e => /^([a-zA-Z0-9_.-])+@giantkiller.com+$/.test(e);

// Here's your uncle Tom at the front of the house.
// Here's your uncle Tom at the back of the house,
// but you can still see the side of the house!

// class declaration
class Login extends Component {
  // default: not loading, until login attempt is made
  constructor() {
    super();

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      showPassword: false,
    };
    this.submitLogin = this.submitLogin.bind(this);
  }

  // submit login to the login action
  submitLogin() {
    this.setState({ isLoading: true });
    var data = { email: this.state.email, password: this.state.password };
    this.props.login(data, (v) => this.onSuccess(v), this.onError.bind(this));
  }

  // submit info to user signup
  submitSignup() {
    this.setState({ isLoading: true });
    var data = { email: this.state.email, password: this.state.password };
    this.props.register(
      data,
      (v) => this.onSuccess(v),
      this.onError.bind(this)
    );
  }

  // if login is successful, access the dashboard
  onSuccess(user) {
    this.setState({ isLoading: false });
    this.props.history.push("/dashboard");
  }

  onError(error) {
    this.setState({ isLoading: false });
    if (error === null) {
      alert("Username or password is incorrect");
    } else {
      alert(error);
    }
  }

  // render return
  render() {
    if (this.state.isLoading) {
      return (
        <LoginWrapper>
          <CircularProgress />
        </LoginWrapper>
      );
    }
    // if not loading
    return (
      <LoginWrapper>
        <Grid
          container
          direction={"row"}
          justify={"center"}
          alignItems={"center"}
        >
          {/* email field */}
          <div style={{ width: 300, margin: 5 }}>
            <TextField
              id="email"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
              fullWidth
            />
          </div>
          <br />
          {/* password field */}
          <div style={{ width: 300, margin: 5 }}>
            <TextField
              id="adornment-password"
              type={this.state.showPassword ? "text" : "password"}
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                      }
                    >
                      {this.state.showPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </Grid>
        {/* button container */}
        <Grid
          container
          direction={"row"}
          justify={"center"}
          alignItems={"center"}
        >
          {/* Login button */}
          <Grid style={{ margin: 5 }}>
            <Button
              type="submit"
              variant="text"
              color="primary"
              onClick={() => this.submitLogin()}
            >
              Login
            </Button>
            <br />
          </Grid>
          {/* Signup button */}
          <Grid style={{ margin: 5 }}>
            <Button
              type="button"
              variant="text"
              color="primary"
              onClick={() => this.submitSignup()}
            >
              Sign Up
            </Button>
            <br />
          </Grid>
        </Grid>
      </LoginWrapper>
    );
  }
}

const mapDispatchToProps = {
  login,
  register,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
